export default __webpack_public_path__ + "static/media/icon_story_6.75a7bc61.svg";